import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SalesTargetCreatePage } from './sales-target-create.page';

const routes: Routes = [
  {
    path: '',
    component: SalesTargetCreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SalesTargetCreatePageRoutingModule {}
